import { toastError } from '@/lib/toast-error';
import { trpc } from '@/lib/trpc';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Hook para crear un nuevo ticket
 * ✨ tRPC hook with full type safety
 */
export function useCreateTicket() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const utils = trpc.useUtils();

  return trpc.tickets.createTicket.useMutation({
    onSuccess: () => {
      toast.success(t('hooks.tickets.ticket_creado_exitosamente'));
      utils.tickets.getAllTickets.invalidate();
      utils.tickets.getMyTickets.invalidate();
      navigate('/tickets/mine');
    },
    onError: (error) => {
      console.error('Error creating ticket:', error);
      toastError(error, 'common.toast.error_al_crear_ticket');
    },
  });
}
